export default [
    'select',
    {
        name: 'name',
        title: 'Shop name',
        sortField: 'name',
        propName: 'name'
    },
    {
        name: 'address.country',
        title: 'Country',
        sortField: 'address.country',
        propName: 'country'
    },
    {
        name: 'address.city',
        title: 'City',
        sortField: 'address.city',
        propName: 'city'
    },
    {
        name: 'externalID',
        title: 'External ID',
        sortField: 'externalID',
        propName: 'externalID'
    },
    {
        name: 'iconURL',
        formatter: value => `<img style="width: auto; max-width: 25px; height: 25px" src=${value}>`,
        title: 'Icon'
    },
    'actions',
    {
        name: 'online',
        sortField: 'online'
    },
    {
        name: 'pages',
        sortField: 'pages'
    }
];
